import { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import styles from './AppLayout.scss'

import CssBaseline from '@material-ui/core/CssBaseline'

import MayorLoader from 'common/components/MayorLoader'
import ModalRoot from 'modules/ModalRoot'

import * as Routes from 'constants/Routes'
import { getIsLoaded as getIsUserLoaded } from 'common/selectors/user'
import { getIsSnackbarVisible, getSnackbarMessage } from 'common/selectors/snackbar'
import { getIsLoaderVisible } from 'common/selectors/loader'
import SnackbarRoot from '../../../../modules/SnackbarRoot/SnackbarRoot'

export class AppLayout extends PureComponent {
  render() {
    const { children, isUserLoaded, isLoaderVisible, shouldHideGlobalLoader } = this.props

    if (!isUserLoaded) {
      return (
        <Fragment>
          <CssBaseline />
          <MayorLoader isVisible />
        </Fragment>
      )
    }

    return (
      <Fragment>
        <CssBaseline />

        <div className={styles.component}>{children}</div>

        <MayorLoader isVisible={isLoaderVisible && !shouldHideGlobalLoader} />
        <SnackbarRoot />
        <ModalRoot />
      </Fragment>
    )
  }
}

const isDashboardRoute = state => {
  const location = state.routing && state.routing.locationBeforeTransitions

  return Boolean(location && location.pathname === Routes.DASHBOARD)
}

const mapStateToProps = state => ({
  isUserLoaded: getIsUserLoaded(state),
  isLoaderVisible: getIsLoaderVisible(state),
  shouldHideGlobalLoader: isDashboardRoute(state),
  isSnackbarVisible: getIsSnackbarVisible(state),
  snackbarMessage: getSnackbarMessage(state)
})

const mapActionsToProps = {
  // Empty
}

export default connect(mapStateToProps, mapActionsToProps)(AppLayout)
